<ng-container *ngIf="state$ | async as state">
  <!--TODO:Remove section and nav-footer class, currently they are necessary to decide which background color is used -->
  <div [ngClass]="state.pageColor ?? ''"
       class="tw-flex tw-flex-wrap tw-flex-col tw-content-center tw-items-center tw-flex-column section nav-footer"
       data-cy="footer"
  >
    <!-- Todo Remove bootstrap container -->
    <div class="container !tw-pr-0 !tw-pl-0">
      <div class="tw-px-6 tw-mx-0 md:tw-px-0 tw-my-12">
        <div class="tw-flex md:tw-flex-row tw-content-center tw-flex-wrap md:tw-justify-between md:tw-flex-nowrap">
          <ul *ngFor="let category of state.main; index as i"
              [class.icon-links-list]="category?.hasIconLinks"
              class="tw-min-w-[50%] md:tw-min-w-fit tw-pl-0 tw-pr-4 tw-mb-8 md:tw-pr-0 md:tw-mb-0 tw-list-none"
              data-cy="footer-links"
          >
            <!--TODO:Remove footer-links-header class, currently they are necessary to decide which background color is used -->
            <li [innerHTML]="category?.label | safeHtml"
                class="footer-links-header tw-font-bold tw-leading-5 md:tw-leading-4 tw-mb-4 md:tw-mb-4 tw-min-h-6 md:tw-min-h-4"
                data-cy="footer-links-header"
            ></li>
            <ng-container *ngFor="let link of category?.children; index as i">
              <li *ngIf="!link?.id && !!link?.length; else textLink"
                  class="tw-flex tw-gap-4 sm:tw-flex-wrap md:tw-flex-nowrap md:tw-gap-8 tw-items-center md:tw-mx-0 tw-my-4"
              >
                <mb-link *ngFor="let iconLink of link"
                         [dataEventAction]="'Click ' + iconLink.label"
                         [linkData]="{ url: iconLink.url, uid: iconLink.cmsLinkType, text: iconLink.label }"
                         [useSlot]="!!iconLink.image?.original"
                         (clickEvent)="sendGTAEvent(iconLink)"
                         dataCy="footer-link"
                         dataEventCategory="FooterNavi"
                         styleClass="normal tw-leading-5"
                >
                  <mb-picture [height]="24"
                              [img]="$any(iconLink.image)"
                              [srcSet]="[{ mediaQuery: mediaQuery.MIN_WIDTH_1, url1x: iconLink.image?.original , url2x: iconLink.image?.original, noWebp: true }]"
                              [width]="24"
                              [pictureClass]="'tw-group'"
                              dataCy="footer-social-link-image"
                              imgClass="tw-w-6 group-has-[img]:tw-w-6"
                  ></mb-picture>
                </mb-link>
              </li>
              <ng-template #textLink>
                <li [class.special-link]="link.cmsLinkType !== cmsLinkType.URL && link.cmsLinkType !== cmsLinkType.CONTENT_LINK">
                  <mb-link [dataEventAction]="'Click ' + link.label"
                           [linkData]="{ url: link.url, uid: link.cmsLinkType, text: link.label }"
                           (clickEvent)="sendGTAEvent(link)"
                           dataCy="footer-link"
                           dataEventCategory="FooterNavi"
                           styleClass="normal tw-leading-5"
                  ></mb-link>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-py-6 tw-bg-white tw-bg-opacity-30">
      <!-- Todo Remove bootstrap container -->
      <div class="container tw-items-start tw-flex-col md:tw-justify-center !tw-px-6 md:!tw-px-0 tw-flex lg:tw-flex-row tw-justify-between tw-gap-2 md:tw-flex-col lg:tw-justify-between">
        <div class="tw-flex tw-flex-col md:tw-flex-row">
          <mb-link *ngFor="let link of state.other.children"
                   [dataEventAction]="'Click ' + link.label"
                   [linkData]="{ url: link.url, uid: link.cmsLinkType, text: link.label }"
                   (clickEvent)="sendGTAEvent(link)"
                   class="other-link"
                   dataCy="footer-link"
                   dataEventCategory="FooterNavi"
                   styleClass="normal tw-leading-5"
          ></mb-link>
        </div>
        <div class="copyright">
          <p [innerHTML]="state.copyright | safeHtml"
             data-cy="footer-copyright"
             class="tw-m-0"
          ></p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
